import React, { useEffect } from "react";
import { Box, CircularProgress, Container, Fade } from "@mui/material";

import SlideIn from "../components/SlideIn";
import { SlideInContextProvider } from "../../context/SlideInContext";
import AppBar from "../components/AppBar";
import PersonManagePage from "./PersonManagePage";
import PersonTableLink from "./PersonTableLink";
import { Navigate, Route, Routes, useNavigate } from "react-router";
import { ViewAllStaff } from "./ViewAllStaff";
import { ManageModal, ManageModalProvider } from "ui";
import AssignPersonLocationPage from "./AssignPersonLocationPage";

const PersonManagementRoutes = () => {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route index element={<ViewAllStaff onBack={() => navigate(-1)} />} />
      <Route path="details/:pid" element={(
        <PersonManagePage
          onLink={(id) => navigate(`/manage/users/link/${id}`)}
          onBack={() => navigate(-1)} />
      )} />
      <Route path={"/location/:pid"} element={<AssignPersonLocationPage onBack={() => navigate(-1)} />} />
      <Route path={`link/:pid`} element={<PersonTableLink onBack={() => navigate(-1)} />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  )
}
export const StaffIndexPage = () => {
  const loading = false

  return (
    <Fade in={true}>
      <Box component="div">
        <SlideInContextProvider>
          <ManageModalProvider>
            <div>
              <SlideIn />
              <ManageModal />
              <AppBar />
            </div>
            <Container maxWidth="xl">
              <Box
                component="div"
                sx={{ paddingTop: "40px", paddingBottom: "32px" }}
              >
                {loading ? (
                  <div
                    style={{
                      width: "100%",
                      height: "50vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : (
                  <PersonManagementRoutes />
                )}
              </Box>
            </Container>
          </ManageModalProvider>
        </SlideInContextProvider>
      </Box>
    </Fade>
  );
};
